module.exports = __webpack_public_path__ + "static/media/eu.a1b765ab.svg";